export const colors = {
  dark: '#2B2C3E',
  light: '#fff',
  darkBlue: '#2B2C3E',
  grey: '#F0F1F2',
  green: '#70A531',
  lightGreen: '#DBE4AF',
  orange: '#FFB500',
  lightOrange: '#F4D292',
  deepOrange: '#E7753A',
  lightBlue: '#A9D3EA',
  pink: `#C92C72`,
  hotPink: `#D04B87`,
  lightPink: `#E2D0DF`,
  teal: '#BCE0DD',
  darkTeal: '#49A5A7',
  turquoise: '#00A3A7',
  sunset: '#F9A885',
}
